import { getMentionUsers } from '../../../../services/popupApi';
import { createNote } from '../../../../services/notesApi';

export const api = {
  getMentionOptions: async (_field, search) => getMentionUsers(search),
  submit: async (values, context) => {
    const relatedId = Array.isArray(context.selectedIds)
      ? context.selectedIds[0]
      : context.selectedIds;

    if (!relatedId) throw new Error('Please select a record before adding a note.');

    await createNote({
      relatedId: String(relatedId),
      notes: values.notes,
      notesFor: context.moduleName,
    });
  },
};
